export class CanvasService {

    private _parentElement: HTMLElement | null;
    private _height: number = 0;
    private _width: number = 0;

    constructor(
        private canvas: HTMLCanvasElement,
    ) {
        this._parentElement = canvas.parentElement;
    }

    getCanvas(): HTMLCanvasElement {
        return this.canvas;
    }

    getRendererSize() {
        this._height = window.innerHeight;
        this._width = (16 / 9) * this._height;

        return {
            width: this._width,
            height: this._height
        };
    }

    getCurrentCanvasSize(): { width: number | undefined, height: number } {
        return {
            width: this._parentElement?.offsetWidth,
            height: window.innerHeight
        };
    }

    get height(): number {
        return this._height;
    }

    set height(value: number) {
        this._height = value;
    }
    get width(): number {
        return this._width;
    }

    set width(value: number) {
        this._width = value;
    }

    get parentElement(): HTMLElement | null {
        return this._parentElement;
    }

    set parentElement(value: HTMLElement | null) {
        this._parentElement = value;
    }
}
